import React from "react";
import "./Popup.css"


type PopupProps = {
  children: React.ReactNode
  _display: "none" | "block" 
}


export default function Popup({ _display, children }: PopupProps) {
  return (
    <div className="popup" style={{ display: _display }}>
      {children}
    </div>
  )
}